import * as S from 'containers/PropertyPanel/PropertyPanel.styles';
import PropertyPanelAccordion from 'containers/PropertyPanel/components/PropertyPanelAccordion';
import PxxInput from '../components/PxxInput';
import PxxInputDisplay from '../components/PxxInputDisplay';
import type { FlowCurvePointInterface } from '../components/FlowCurve';

type Props = {
  pxxPoints: FlowCurvePointInterface[] | undefined;
};

const PxxValues = ({ pxxPoints }: Props) => {
  const layout = [
    ['2', '2', '2'],
    ['2', '2', '2'],
  ];

  return (
    <PropertyPanelAccordion title='PXX Values' defaultExpanded>
      <S.GridLayout layout={layout}>
        <PxxInput field='pxxOne' />
        <PxxInput field='pxxTwo' />
        <PxxInput field='pxxThree' />
        <PxxInputDisplay field='pxxOne' pxxPoints={pxxPoints} />
        <PxxInputDisplay field='pxxTwo' pxxPoints={pxxPoints} />
        <PxxInputDisplay field='pxxThree' pxxPoints={pxxPoints} />
      </S.GridLayout>
    </PropertyPanelAccordion>
  );
};

export default PxxValues;
